import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import Cookies from "js-cookie";
import axios from "axios";

// Import components
import LinkedInHeader from './components/LinkedInHeader';
import FeedPage from './components/FeedPage';
import SearchPage from './components/SearchPage';
import CompanyPage from './components/Company/CompanyPage';
import RatingsPage from './components/RatingsPage';
import NotificationsPage from './components/NotificationsPage';
import PortfolioAnalyser from './components/PortfolioAnalyser';
import SubscriptionPage from './components/SubscriptionPage';
import OverUndervalued from './components/OverUndervalued/OverUndervalued';
import LoginPage from './components/auth/LoginPage';
import ConfirmEmailPage from './components/auth/ConfirmEmailPage';
import RegisterPage from './components/auth/RegisterPage';
import ForgotPasswordPage from './components/auth/ForgotPasswordPage';
import ForgotPasswordResetPage from './components/auth/ForgotPasswordResetPage';
import DocNotifications from './components/docs/DocNotifications';
import TermsPage from './components/docs/TermsPage';
import PrivacyPolicyPage from './components/docs/PrivacyPolicyPage';
import CookiePolicyPage from './components/docs/CookiePolicyPage';

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const openCompanyPage = (stock, new_tab = false) => {
    // setSelectedStock(stock);
    const url = `/company-statistic/${stock.id}/${stock.slug}`;
    if(new_tab == true) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };
  
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedStock, setSelectedStock] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [sectorFilter, setSectorFilter] = useState('all');
  const [ratingFilter, setRatingFilter] = useState('all');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Get current page from location
  const getCurrentPage = () => {
    const path = location.pathname.substring(1) || 'feed';
    return path;
  };

  // Navigation function using React Router
  const setCurrentPage = (page) => {
    navigate(`/${page === 'feed' ? '' : page}`);
  };

  async function setTitleDescription(title, description_text) {
    document.title = title;
    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute('content',description_text);
    } else {
      // Если тега <meta name="description"> нет, создаём его
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description_text;
      document.head.appendChild(meta);
    }
  }

  const currentPage = getCurrentPage();

  const [authStatus, setAuthStatus] = useState(null);

  // const checkUserAuth = useCallback(async () => {
  async function checkUserAuth() {
    const token = Cookies.get('token')
    if(!token) {
      setAuthStatus(false);
      return "";
    }
    const data = { token: token }
    try{
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(apiURL+'/user/auth_check', data)
      if(response.data.status === 'ok') {
        Cookies.set('email', response.data.email, { expires: 1, path: '/'});
        Cookies.set('token', response.data.token, { expires: 1, path: '/'});
        Cookies.set('subscribe', response.data.subscribe, { expires: 1, path: '/'});
        setAuthStatus(true);

        if(response.data.email_verified_at === null) {
          setCurrentPage("auth/confirm-email");
          return "";
        }
      } else {
        setAuthStatus(false);
        return "";
      }
    } catch(e) {
      await delay(2000);
      await checkUserAuth();
    }
  // }, [router]);
  }

  useEffect(() => {
    checkUserAuth();
  }, []);

  const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
  );

  return (
    <div className="App">
      {!['auth/login', 'auth/signup', 'auth/confirm-email', 'auth/forgot-password', 'auth/forgot-password/reset'].includes(currentPage) && (
        <LinkedInHeader 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
          authStatus={authStatus}
          setAuthStatus={setAuthStatus}
        />
      )}
      
      <Routes>
        {/* Default route - Feed Page */}
        <Route 
          path="/" 
          element={
            <FeedPage
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              setTitleDescription={setTitleDescription}
              openCompanyPage={openCompanyPage}
            />
          } 
        />
        
        <Route 
          path="/docs/terms" 
          element={
            <TermsPage
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              setTitleDescription={setTitleDescription}
            />
          }
        />
        
        <Route 
          path="/docs/privacy-policy" 
          element={
            <PrivacyPolicyPage 
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              setTitleDescription={setTitleDescription}
            />
          }
        />

        <Route 
          path="/docs/cookie-policy" 
          element={
            <CookiePolicyPage 
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              setTitleDescription={setTitleDescription}
            />
          }
        />
        
        {/* Feed Page */}
        {/* <Route 
          path="/feed" 
          element={
            <FeedPage 
              
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              setTitleDescription={setTitleDescription}
            />
          } 
        /> */}
        
        {/* Search Page */}
        <Route 
          path="/search" 
          element={
            <SearchPage 
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              setTitleDescription={setTitleDescription}
              openCompanyPage={openCompanyPage}
            />
          } 
        />
        
        {/* Company Page with dynamic symbol parameter */}
        <Route 
          path="/company-statistic/:id/:slug" 
          element={
            <CompanyPage 
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          } 
        />
        
        {/* Ratings Page */}
        <Route 
          path="/ratings" 
          element={
            <RatingsPage 
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
              openCompanyPage={openCompanyPage}
            />
          } 
        />
        
        {/* Subscription Page */}
        <Route 
          path="/subscriptions" 
          element={
            <SubscriptionPage 
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
              authStatus={authStatus}
            />
          } 
        />

        
        {/* Over & Undervalued Companies Page */}
        <Route 
          path="/over-undervalued-companies" 
          element={
            <OverUndervalued 
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
              openCompanyPage={openCompanyPage}
              authStatus={authStatus}
            />
          } 
        />
        
        {/* Notifications Page */}
        <Route 
          path="/notifications" 
          element={
            <NotificationsPage 
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
              openCompanyPage={openCompanyPage}
              authStatus={authStatus}
            />
          } 
        />
        
        {/* Portfolio Analyser Page */}
        <Route 
          path="/portfolio" 
          element={
            <PortfolioAnalyser 
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
            />
          } 
        />
        
        {/* Login Page */}
        <Route 
          path="/auth/login" 
          element={
            <LoginPage 
              authStatus={authStatus}
              setAuthStatus={setAuthStatus}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
            />
          } 
        />

         <Route 
          path="/auth/confirm-email" 
          element={
            <ConfirmEmailPage 
              setIsLoggedIn={setIsLoggedIn}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
            />
          } 
        />

        {/* Register Page */}
        <Route 
          path="/auth/signup" 
          element={
            <RegisterPage 
              authStatus={authStatus}
              setAuthStatus={setAuthStatus}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
            />
          } 
        />

        {/* Forgot Password Page */}
        <Route 
          path="/auth/forgot-password" 
          element={
            <ForgotPasswordPage 
              authStatus={authStatus}
              setAuthStatus={setAuthStatus}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
            />
          } 
        />
        
        {/* Forgot Password Page */}
        <Route 
          path="/auth/forgot-password/reset" 
          element={
            <ForgotPasswordResetPage 
              authStatus={authStatus}
              setAuthStatus={setAuthStatus}
              setCurrentPage={setCurrentPage}
              setTitleDescription={setTitleDescription}
            />
          } 
        />

      </Routes>

      <DocNotifications />
    </div>
  );
};

export default App;